// extracted by mini-css-extract-plugin
export var logo = "_l1-2";
export var logoWrapper = "_l1-1";
export var strip = "_l1-0";